module.exports = __webpack_public_path__ + "static/media/Silestone-Flash-Promo-Flyer-USA.e6424fd1.pdf";